import { getContentReviews, getContentReviewById, updateContentReview } from '../services/napi';
import {
  CONTENT_REVIEW_FETCH_SUCCESS,
  CONTENT_REVIEW_FETCH_FAIL,
  CONTENT_REVIEW_FETCH_BY_ID_SUCCESS,
  CONTENT_REVIEW_FETCH_BY_ID_FAIL,
  CONTENT_REVIEW_SET_DRAFT
} from '../constant/actionType';

function fetchContentError() {
  return {
    error: 'CONTENT_FETCH_FAIL',
    type: CONTENT_REVIEW_FETCH_FAIL
  };
}

function fetchContentByIdError() {
  return {
    error: 'CONTENT_FETCH_BY_ID_FAIL',
    type: CONTENT_REVIEW_FETCH_BY_ID_FAIL
  };
}

export function fetchContentReviews() {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;

      const response = await getContentReviews(projectId);

      dispatch({ data: response.data, type: CONTENT_REVIEW_FETCH_SUCCESS });
    } catch (error) {
      dispatch(fetchContentError());
    }
  };
}

export function fetchContentReviewById(id, updateDraft = false) {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;

      const response = await getContentReviewById(id, projectId);

      dispatch({ data: response.data, type: CONTENT_REVIEW_FETCH_BY_ID_SUCCESS });

      if (updateDraft) {
        dispatch({ data: response.data.review, type: CONTENT_REVIEW_SET_DRAFT });
      }
    } catch (error) {
      dispatch(fetchContentByIdError());
    }
  };
}

export function updateContentReviewAction(id, reviewStatus) {
  return async (dispatch, getState) => {
    try {
      const contentReview = getState().contentReview.contentReviewDraft;
      const { _id: projectId } = getState().project.currentProject;
      contentReview.reviewStatus = reviewStatus;
      await updateContentReview(id, projectId, contentReview);
    } catch (error) {
      dispatch(fetchContentError());
    }
  };
}
export function setContentReviewDraft(content) {
  return async (dispatch) => {
    try {
      dispatch({ data: content, type: CONTENT_REVIEW_SET_DRAFT });
    } catch (error) {
      dispatch(fetchContentError());
    }
  };
}
